export default {
    items: [
        {
            type: 'radio-list',
            name: 'type',
            props: {
                label: 'Type of Employer',
                row: true,
                items: [
                    {
                        text: 'You (personally/individually)',
                        value: 'you'
                    },
                    {
                        text: 'Your Company (e.g., LLC handles payroll)',
                        value: 'company'
                    }
                ]
            }
        },
        {
            type: 'text-field',
            name: 'employer-name',
            props: {
                label: 'Employer Full Legal Name'
            }
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'address',
                    width: 12,
                    props: {
                        label: 'Address',
                    },
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'city',
                    width: 6,
                    props: {
                        label: 'City'
                    }
                },
                {
                    type: 'selectlist',
                    name: 'state',
                    width: 2,
                    props: {
                        label: 'State',
                        items: []
                    }
                },
                {
                    type: 'text-field',
                    name: 'zip',
                    width: 4,
                    props: {
                        label: 'Zip',
                        format: 'zip'
                    }
                }
            ]
        },
        {
            type: 'selectlist',
            name: 'entity-type',
            width: 6,
            props: {
                label: 'Entity Type',
                items: []
            }
        },
        {
            type: 'textarea',
            name: 'titles-roles',
            width: 12,
            props: {
                label: 'Titles/Roles of Employees'
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/employment-resources/data_table_forms/employer-information.js